<template>
    <div ref="echart" class="echart"></div>
</template>

<script>
import {mixinCreateEchart} from '@/views/TheHome/mixins/createEchart'

export default {
  name: 'selectBar',
  mixins: [mixinCreateEchart],
  props: {
    value: Object
  },
  data () {
    return {
      option: {
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          position: [10, 10],
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          top: '3%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            nameRotate: 12,
            data: this.value.xAxis,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '直接访问',
            type: 'bar',
            barWidth: '8px',
            data: this.value.series
          }
        ]
      }
    }
  },
  methods: {
    changeEchart () {
      this.echart.setOption({
        xAxis: [{data: this.value.xAxis}],
        series: [{
          data: this.value.series
        }]
      })
    }
  }
}
</script>

<style scoped>
    .echart {
        width: 100%;
        height: 100%;
    }
</style>
